module.exports = __webpack_public_path__ + "static/ga-c70f7ddf97853a0147162edbab3a1d5d.png";